import React, { useEffect, useState } from 'react';
import {
  Box,
  Stack,
  Container,
  Typography,
  Snackbar,
  Alert,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Checkbox,
  IconButton,
  MenuItem,
  Menu,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Pagination,
  PaginationItem,
  Grid,
  Avatar,
  Rating,
  TextField
} from '@mui/material';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
import Page from '../../components/Page';
import Iconify from 'src/components/Iconify';

//icons
import Empty_Truck from '../../../src/asset/open-door.png';
import { api } from 'src/Api';
import { LoadingButton } from '@mui/lab';
import moment from 'moment';
import Searchbar from 'src/layouts/dashboard/Searchbar';
import { TableNoData } from 'src/components/NoData';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import CloseIcon from '@mui/icons-material/Close';
import { NumericFormat } from 'react-number-format';
import BookerProfileComponent from 'src/components/BookerProfileComponent';
import ReactQuill from 'react-quill';

export default function ShipmentTruckRequest() {
  const navigate = useNavigate();
  const location = useLocation();
  const { shipment_id } = location.state || {};
  const userData = JSON.parse(localStorage.getItem('user'));

  const [trucksList, setTrucksList] = useState([]);

  const [loading, setloading] = useState(false);
  const [loadingCompany, setloadingCompany] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const [anchorEl, setAnchorEl] = useState(null); // For 3-dot menu control
  const [selectedTruck, setSelectedTruck] = useState(null); // Track which truck is selected for menu
  const [companyData, setCompanyData] = useState(null); // Track which truck is selected for menu

  const [pagesCount, setpagesCount] = useState(1);
  const [page, setPage] = useState(1);

  const [openDetailsModal, setOpenDetailsModal] = useState(false);

  const [searchLoading, setsearchLoading] = useState(false);
  const [loadingInvite, setloadingInvite] = useState(false);
  const [search, setsearch] = useState('');

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [milesFilter, setMilesFilter] = useState('');

  const [message, setMessage] = useState('');
  const [openInviteDialog, setOpenInviteDialog] = useState(false);

  useEffect(() => {
    if (search.length == 0) {
      trucksList.length = 0;
      getRequestTruck(page);
    }
  }, [search]);

  useEffect(() => {
    getRequestTruck(page);
  }, [page, startDate, endDate, milesFilter]);

  // const handleInviteFunction = () => {
  //   if (message) {
  //     sendMessage();
  //     handleSendInvitation();
  //   } else {
  //     handleSendInvitation();
  //   }
  // };

  function getRequestTruck(page) {
    setloading(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    const queryParams = new URLSearchParams();
    search.length > 0 && queryParams.append('search', search);
    page && queryParams.append('page', page);
    queryParams.append('shipment_id', shipment_id);
    startDate && queryParams.append('start_date', moment(startDate).format('YYYY-MM-DD'));
    endDate && queryParams.append('end_date', moment(endDate).format('YYYY-MM-DD'));
    milesFilter && queryParams.append('miles', milesFilter);

    fetch(`${api.get_request_a_truck}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setTrucksList(result.data);
          result?.count ? setpagesCount(Math.ceil(result?.count / 10)) : setpagesCount(1);
          setloading(false);
        } else {
          setTrucksList([]);
          setpagesCount(0);
          setloading(false);
        }
      })
      .catch((error) => {
        console.log('error', error);
        setloading(false);
      });
  }

  function getRequestTruckProfile() {
    setloadingCompany(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    const queryParams = new URLSearchParams();
    queryParams.append('user_id', selectedTruck?.company?.id);
    queryParams.append('profile_type', 'Booker');

    fetch(`${api.get_profiles}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setCompanyData(result.data[0]);
          handleOpenDetailsModal();
          setloadingCompany(false);
        } else {
          setloadingCompany(false);
        }
      })
      .catch((error) => {
        console.log('error', error);
        setloadingCompany(false);
      });
  }

  const handleOpenInviteDialog = () => {
    setOpenInviteDialog(true);
    setAnchorEl(null);
  };

  const handleCloseInviteDialog = () => {
    setOpenInviteDialog(false);
    setMessage('');
  };

  function handleSendInvitation() {
    setloadingInvite(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      redirect: 'follow'
    };

    const queryParams = new URLSearchParams();
    queryParams.append('request_id', shipment_id);
    queryParams.append('request_to_id', selectedTruck?.company?.id);
    queryParams.append('request_by', 'Shipper');
    queryParams.append('booking_id', selectedTruck?.id);
    message && queryParams.append('message', message);

    fetch(`${api.send_invitation}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          setloadingInvite(false);
          handleMenuClose();
          handleCloseInviteDialog();
        } else {
          setSnackbarMessage(result.message);
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
          setloadingInvite(false);
        }
      })
      .catch((error) => {
        console.log('error', error);
        setSnackbarMessage('An error occurred.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setloadingInvite(false);
      });
  }

  const handleMenuClick = (event, truck) => {
    setAnchorEl(event.currentTarget);
    setSelectedTruck(truck); // Set the truck for which menu is open
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedTruck(null); // Reset the selected truck
  };

  const handleOpenDetailsModal = () => {
    setOpenDetailsModal(true);
    setAnchorEl(null);
  };

  const handleCloseDetailsModal = () => {
    setOpenDetailsModal(false);
    setSelectedTruck(null);
  };

  const handlePageChange = (event, value) => {
    trucksList.length = 0;
    setPage(value);
    getRequestTruck(value);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleStartDateChange = (value) => {
    setStartDate(value ? value.toISOString() : null);
  };

  const handleEndDateChange = (value) => {
    setEndDate(value ? value.toISOString() : null);
  };
  const handleClearFilter = () => {
    setStartDate(null);
    setEndDate(null);
    setMilesFilter('');
  };

  return (
    <Page title={`My Shipment  | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="flex-start" mb={2}>
          <IconButton
            style={{
              marginRight: 12,
              height: 40,
              width: 70,
              borderRadius: 5,
              backgroundColor: 'rgba(209,209,209,0.3)'
            }}
            onClick={() => navigate(-1)}
          >
            <Iconify icon="ion:return-up-back" style={{ fontSize: 25, color: '#010f58' }} />
          </IconButton>
          <Typography variant="h4" sx={{ color: '#010f58' }}>
            Request a Truck
          </Typography>
        </Stack>

        <Box sx={{ marginTop: 2 }}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={3.62} md={3.66}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="custom-textfield"
                  sx={{ width: '100%' }}
                  label="Start Date"
                  value={startDate ? dayjs(startDate) : null}
                  onChange={(newValue) => handleStartDateChange(newValue)}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={3.62} md={3.66}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  className="custom-textfield"
                  sx={{ width: '100%' }}
                  label="End Date"
                  value={endDate ? dayjs(endDate) : null}
                  onChange={(newValue) => handleEndDateChange(newValue)}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={3.62} md={3.66}>
              <TextField
                sx={{ width: '100%' }}
                className="custom-textfield"
                type="number"
                placeholder="Miles"
                value={milesFilter}
                onChange={(e) => {
                  setMilesFilter(e.target.value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={1} md={1}>
              <Button
                variant="contained"
                color="primary"
                sx={{ height: 50, width: '100%' }}
                onClick={handleClearFilter}
              >
                <CloseIcon />
              </Button>
            </Grid>
          </Grid>
        </Box>

        {/* Search bar */}
        <Box
          style={{
            flexDirection: 'column',
            display: 'flex',
            flex: 1,
            marginTop: 10
          }}
          className="top_column"
        >
          <Box
            style={{
              flexDirection: 'row',
              display: 'flex',
              flex: 1
            }}
            className="top_column"
          >
            <Searchbar
              width={'100%'}
              fullWidth
              setFunction={(val) => {
                setsearch(val);
              }}
              className="width_full_property"
              placeholder={'Search Requests'}
              onEnter={() => {
                setsearchLoading(true);
                trucksList.length = 0;
                getRequestTruck();
              }}
            />
            <LoadingButton
              style={{ width: '15%', marginLeft: '2%' }}
              variant="contained"
              className="width_full_status"
              loading={searchLoading}
              onClick={() => {
                setsearchLoading(true);
                setPage(1);
                getRequestTruck(1);
              }}
            >
              <Iconify icon="material-symbols:search" sx={{ width: 25, height: 25 }} />
            </LoadingButton>
          </Box>
        </Box>

        <TableContainer
          component={Paper}
          sx={{ boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.1)', mt: 2, mb: 2 }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>COMPANY</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>TRUCK</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>RATE</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>REFERENCE</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>AVAILABLE</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>TRIP</TableCell>
                <TableCell
                  align="right"
                  sx={{
                    fontSize: '12px',
                    color: '#010f58',
                    position: 'sticky',
                    right: 0,
                    zIndex: 1,
                    backgroundColor: '#fff',
                    width: 80
                  }}
                >
                  ACTION
                </TableCell>
              </TableRow>
            </TableHead>
            {!loading && (
              <TableBody>
                {trucksList.map((truck, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell scope="row" padding="normal">
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Avatar
                            sx={{
                              width: 42, // Adjust size if needed
                              height: 42,
                              objectFit: 'contain'
                            }}
                            alt={truck?.company?.company}
                            src={truck?.company?.avatar}
                          />
                          <Box style={{ display: 'flex', flexDirection: 'column', width: 120 }}>
                            <Typography variant="subtitle2" flexWrap={'wrap'}>
                              {truck?.company?.company || 'N/A'}
                            </Typography>
                          </Box>
                        </Stack>
                      </TableCell>

                      <TableCell>
                        <Typography style={{ fontSize: 12, width: 170 }}>
                          {`${truck?.equipment_type || '-'} | ${truck?.equipment_name || '-'} | ${
                            truck?.weight_lbs || '-'
                          } ${truck?.weight_unit || '-'} | ${truck?.length_ft || '-'} ${
                            truck?.length_unit || '-'
                          }`}
                        </Typography>
                      </TableCell>

                      <TableCell style={{ fontSize: 12, width: 75 }}>
                        {truck.rate ? (
                          <NumericFormat
                            value={truck.rate ? parseFloat(truck.rate).toFixed(2) : '0.00'}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                          />
                        ) : (
                          '-'
                        )}
                      </TableCell>
                      <TableCell style={{ fontSize: 12, width: 75 }}>
                        {truck?.reference_id}
                      </TableCell>

                      <TableCell>
                        {truck?.available}
                        <Typography style={{ fontSize: 12, width: 75 }}>
                          {moment(truck?.startdate).format('MM/DD/YYYY')} -{' '}
                          {moment(truck?.enddate).format('MM/DD/YYYY')}
                        </Typography>
                      </TableCell>

                      <TableCell sx={{ fontSize: '12px' }}>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            justifyContent: 'flex-start'
                          }}
                        >
                          <p
                            style={{
                              fontWeight: 'bold',
                              color: '#010f58',
                              marginRight: 5,
                              fontSize: 10
                            }}
                          >
                            {truck?.total_mil || '-'}
                          </p>
                          <div>
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                marginBottom: -5
                              }}
                            >
                              <div
                                style={{
                                  height: 6,
                                  width: 6,
                                  borderRadius: 100,
                                  backgroundColor: 'white',
                                  border: '2px solid #010f58',
                                  marginRight: 5
                                }}
                              ></div>
                              <p
                                style={{
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  maxWidth: '150px' // Adjust this width as needed
                                }}
                              >
                                {truck?.location_origin}
                              </p>
                            </div>
                            <div>
                              <Iconify
                                icon="mingcute:arrow-down-line"
                                style={{ fontSize: 14, marginLeft: -4.6, color: '#010f58' }}
                              />
                            </div>
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                marginTop: -10
                              }}
                            >
                              <div
                                style={{
                                  height: 6,
                                  width: 6,
                                  borderRadius: 100,
                                  backgroundColor: '#010f58',
                                  border: '2px solid #010f58',
                                  marginRight: 5
                                }}
                              ></div>
                              <p
                                style={{
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  maxWidth: '150px' // Adjust this width as needed
                                }}
                              >
                                {truck?.location_destination}
                              </p>
                            </div>
                          </div>
                        </div>
                      </TableCell>

                      <TableCell
                        align="right"
                        style={{
                          position: 'sticky',
                          right: 0,
                          zIndex: 1,
                          background: '#fff'
                        }}
                      >
                        <IconButton onClick={(e) => handleMenuClick(e, truck)}>
                          <Iconify icon="iwwa:option" style={{ fontSize: 20, color: '#010f58' }} />
                        </IconButton>
                        <Menu
                          anchorEl={anchorEl}
                          open={Boolean(anchorEl)}
                          onClose={handleMenuClose}
                        >
                          <MenuItem
                            sx={{ fontSize: 12 }}
                            onClick={handleOpenInviteDialog}
                            disabled={truck?.request_status}
                          >
                            {/* {loadingInvite ? (
                                <CircularProgress size={12} sx={{ alignContent: 'center' }} />
                              ) : ( */}
                            Invite
                            {/* )} */}
                          </MenuItem>
                          <MenuItem
                            sx={{ fontSize: 12, width: 100 }}
                            onClick={getRequestTruckProfile}
                          >
                            {loadingCompany ? (
                              <CircularProgress size={12} sx={{ alignContent: 'center' }} />
                            ) : (
                              'View Profile'
                            )}
                          </MenuItem>
                        </Menu>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            )}

            {/* loader */}
            {loading && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={7} sx={{ py: 3 }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}

            {/* empty list */}
            {trucksList.length == 0 && !loading && <TableNoData colSpan={7} />}
          </Table>
        </TableContainer>

        {/* Pagination */}
        {!loading && pagesCount > 1 && trucksList.length !== 0 && (
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              marginTop: 20,
              alignItems: 'center',
              marginBottom: 20
            }}
          >
            <Pagination
              color="primary"
              shape="rounded"
              page={page}
              size="small"
              count={pagesCount}
              onChange={handlePageChange}
              renderItem={(item) => <PaginationItem {...item} />}
            />
          </Box>
        )}

        <BookerProfileComponent
          companyData={companyData}
          onClose={handleCloseDetailsModal}
          open={openDetailsModal}
        />

        <Dialog open={openInviteDialog} onClose={handleCloseInviteDialog} fullWidth>
          <DialogTitle>Send Invitation</DialogTitle>
          <DialogContent>
            <ReactQuill
              modules={{
                toolbar: [
                  [{ header: [1, 2, false] }],
                  ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                  [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
                  ['link', 'image'],
                  ['emoji'],
                  ['clean']
                ],
                'emoji-toolbar': true,
                'emoji-textarea': false,
                'emoji-shortname': true
              }}
              value={message}
              onChange={setMessage}
              placeholder="Write your message..."
              style={{ marginBottom: 10 }}
            />
          </DialogContent>
          <DialogActions sx={{ paddingRight: 3, paddingBottom: 2 }}>
            <Button onClick={handleCloseInviteDialog} color="primary">
              Cancel
            </Button>
            <LoadingButton
              loading={loadingInvite}
              onClick={handleSendInvitation}
              color="primary"
              variant="contained"
            >
              Send
            </LoadingButton>
          </DialogActions>
        </Dialog>

        <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Container>
    </Page>
  );
}
